import { useState, useCallback } from 'react'
import { createPortal } from 'react-dom'

interface TooltipState {
  visible: boolean
  x: number
  y: number
  text: string
}

export const useFollowTooltip = () => {
  const [tooltip, setTooltip] = useState<TooltipState>({
    visible: false,
    x: 0,
    y: 0,
    text: '',
  })

  const showTooltip = useCallback((e: React.MouseEvent, text: string) => {
    if (text) {
      setTooltip({
        visible: true,
        x: e.clientX,
        y: e.clientY,
        text,
      })
    }
  }, [])

  const hideTooltip = useCallback(() => {
    setTooltip(prev => ({ ...prev, visible: false }))
  }, [])

  const getTooltipProps = (text: string) => ({
    onMouseMove: (e: React.MouseEvent) => showTooltip(e, text),
    onMouseLeave: hideTooltip,
  })

  return {
    tooltip,
    showTooltip,
    hideTooltip,
    getTooltipProps,
  }
}

export const FollowTooltip = ({
  visible,
  x,
  y,
  text,
  className,
}: TooltipState & { className?: string }) => {
  if (typeof window === 'undefined' || !visible) return null

  return createPortal(
    <div
      className={
        className ||
        'pointer-events-none fixed z-[9999] max-w-xs rounded-lg bg-black/60 px-3 py-2 text-sm font-bold text-white shadow-lg backdrop-blur-sm transition-opacity duration-200'
      }
      style={{
        left: `${x + 16}px`,
        top: `${y + 16}px`,
      }}
    >
      {text}
    </div>,
    document.body
  )
}

export default useFollowTooltip
